export default "__VITE_PUBLIC_ASSET__0d7bffa6__"